export default class AuthRequest {

    public email: string = ''
    public password: string = ''
    public rememberMe: boolean = false
}
